import React from 'react';
import { Tooltip } from 'react-leaflet';
import { StyledDeviceIdTooltipInner } from '../../Styled';
import { Device } from 'types/device';

export default function DeviceIdTooltip({ device }: { device: Device }) {

  return (
    <Tooltip className="tooltip-small" opacity={1} direction="left" permanent offset={[-18, 0]}>
      <StyledDeviceIdTooltipInner id={`username-tooltip-${device.device_id}`}>
        <span>{device.device_id}</span>
      </StyledDeviceIdTooltipInner>
    </Tooltip>
  );
}
